/**
 * Cross-module helper: maps a semantic tone to a `Badge`-renderable tone. `Badge` has no
 * "danger" tone, so "danger" is displayed as "warn" (matches JobsModule's failed→warn convention).
 *
 * @param tone - The semantic tone to convert.
 * @returns The equivalent tone `Badge` supports ("danger" becomes "warn"; others pass through unchanged).
 */
export function toBadgeTone(tone: "neutral" | "ok" | "warn" | "danger"): "neutral" | "ok" | "warn" | "accent" {
  return tone === "danger" ? "warn" : tone;
}
